var level3Task0 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
  <variables>
    <variable id="6Yp_gqbzVwZ/!$jYc1MF">garden_list</variable>
    <variable id="WYwbO;q1uv|FW1cJawo*">list</variable>
  </variables>
  <block type="variables_set" id="73=0Xb,5~|6Pki6QNVO/" x="-62" y="38">
    <field name="VAR" id="6Yp_gqbzVwZ/!$jYc1MF">garden_list</field>
    <value name="VALUE">
      <block type="lists_create_with" id="?LVh21=M37H09B},,p(">
        <mutation items="3"></mutation>
        <value name="ADD0">
          <block type="text" id="j.jW#z9pz16B:6Mnejn{">
            <field name="TEXT"> tomatoes </field>
          </block>
        </value>
        <value name="ADD1">
          <block type="text" id="l(!o}wf+5Zipkv.S/ND~">
            <field name="TEXT"> blueberries </field>
          </block>
        </value>
        <value name="ADD2">
          <block type="text" id="MvJyLm[5}m7zcSjQTys">
            <field name="TEXT"> carrots </field>
          </block>
        </value>
      </block>
    </value>
    <next>
      <block type="lists_setIndex" id="~8!+JXU5s.qL!$P$$=Vx">
        <mutation at="true"></mutation>
        <field name="MODE">SET</field>
        <field name="WHERE">FROM_START</field>
        <value name="LIST">
            <block type="variables_get" id="oqj3f#E~2*)2$9BWH7.m">
            <field name="VAR" id="6Yp_gqbzVwZ/!$jYc1MF">garden_list</field>
            </block>
        </value>
        <value name="AT">
          <block type="math_number" id="X]*WKH_{L$(Hetr#=(k$">
            <field name="NUM">1</field>
          </block>
        </value>
        <value name="TO">
          <block type="text" id="RGw9!v#,3r1B(eZg7S/a">
            <field name="TEXT">cucumbers</field>
          </block>
        </value>
        <next>
          <block type="text_print" id="-s5o,L3Sipx(%dC^Sy|z">
            <value name="TEXT">
              <block type="variables_get" id="oqj3f#E~2*)2$9BWH7.m">
                <field name="VAR" id="6Yp_gqbzVwZ/!$jYc1MF">garden_list</field>
              </block>
            </value>
          </block>
        </next>
      </block>
    </next>
  </block>
</xml>
`
export default level3Task0
